import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { firstValueFrom } from 'rxjs/internal/firstValueFrom';
import { deserialize, serialize } from 'bson';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';

class NgxBsonService {
    constructor(http) {
        this.http = http;
    }
    async postBson(endpoint, body) {
        const tansformedbody = this.transformToBson(body);
        const res = await firstValueFrom(this.http.post(endpoint, tansformedbody, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/octet-stream',
                'accept': 'application/octet-stream'
            }
        }));
        return await this.transformToType(res);
    }
    async getBson(endpoint) {
        const res = await firstValueFrom(this.http.get(endpoint, {
            responseType: 'arraybuffer',
            headers: {
                'accept': 'application/octet-stream',
                'Content-Type': 'application/octet-stream'
            }
        }));
        return await this.transformToType(res);
    }
    transformToType(buffer) {
        return deserialize(buffer);
    }
    transformToBson(body) {
        const buffer = serialize(body);
        return new Blob([buffer]);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class NgxBsonComponent {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.4", type: NgxBsonComponent, selector: "lib-ngx-bson", ngImport: i0, template: `
    <p>
      ngx-bson works!
    </p>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-ngx-bson', template: `
    <p>
      ngx-bson works!
    </p>
  ` }]
        }] });

class NgxBsonModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonModule, declarations: [NgxBsonComponent], imports: [HttpClientModule], exports: [NgxBsonComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonModule, imports: [HttpClientModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.4", ngImport: i0, type: NgxBsonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NgxBsonComponent
                    ],
                    imports: [
                        HttpClientModule
                    ],
                    exports: [
                        NgxBsonComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of ngx-bson
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxBsonComponent, NgxBsonModule, NgxBsonService };
